import { useState, useEffect } from 'react';

export const useBatchForm = (open: boolean) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [form, setForm] = useState({
        batch_uuid: '',
        type: '',
        body: {},
        limit: 0,
    });

    const onHandleChange = (field, field2, e) => {
        let f = form;
        if (field && !field2) {
            f[field] = field === 'limit' ? Number(e.target.value) : e.target.value;
        }
        if (field2) {
            f[field][field2] = e.target.value;
        }
        if (field === 'type') {
            f['body'] = {};
        }
        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
    };

    const validateForm = (f) => {
        if (f['batch_uuid'] && f['type'] && f['limit']) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }
    };

    useEffect(() => {
        if (!open) {
            setForm(
                JSON.parse(
                    JSON.stringify({
                        batch_uuid: '',
                        type: '',
                        body: {},
                        limit: 0,
                    })
                )
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return { form, onHandleChange, isValidForm };
};
